import React from "react";
import opbouwLatijn from "../../data/opbouw-spqr";
import opbouwGrieks from "../../data/opbouw-argo";

export default ({ book, chapter }) => {
  const opbouw = book == "spqr" ? opbouwLatijn : opbouwGrieks;
  const thema = opbouw[chapter - 1].thema;
  const name = opbouw[chapter - 1].name;
  const slugName = name.toLowerCase().replace(/\s/g, "_");
  const href = `/${book}/thema_${thema}/${chapter}._${slugName}/${chapter}._tekst/`;

  return (
    <div>
      <h2>Klaar?</h2>
      <p>
        <a href={href}>{`Ga verder met tekst ${chapter}`}</a>
      </p>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/grammatica/Klaar.js